import { Button } from "@mui/joy";
import { DataGridPremium } from "@mui/x-data-grid-premium";
import React, {useEffect,useState} from "react";

const CleanerSalaryConfig : React.FC<any> = (props) => {

    const [rows, setRows] = useState<any[]>([]);
    const [columns, setColumns] = useState<any[]>([
        { 
            field : "name", headerName : "이름", width : 100
        },
        {
            field : "houryWage", headerName : "시간당 급여", width : 150
        }
    ]);

    useEffect(() => {



    }, []);


    return (
        <div>
            <div style={{
                fontSize: "20px",
                fontWeight: 600,
                marginTop : "40px"
            }}>
                클리너 급여 설정
            </div>
            <div style={{
                display : "flex",
                justifyContent : "space-between",
                width : "1200px"
            }}>
                <div>

                </div>
                <div>
                    <Button
                        variant="soft"
                        color="primary"
                        size="md"
                    >
                        청소 직원 추가
                    </Button>
                </div>
            </div>
            <div style={{ height: 400, width: '1200px', marginTop: "20px" }}>
                <DataGridPremium
                    rows={rows}
                    columns={columns}
                    hideFooter
                />
            </div>
        </div>
    )
}

export default CleanerSalaryConfig;